import { ENTERPRISE_CORE_SEAT, PROFESSIONAL_CORE_SEAT } from '../scopeConstants';
export const getHasCoreEnterpriseSeat = scopes => {
  return scopes.includes(ENTERPRISE_CORE_SEAT);
};
export const getHasCoreProSeat = scopes => {
  return scopes.includes(PROFESSIONAL_CORE_SEAT);
};